import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "features/auth/hooks/useAuth";
import { ThemeProvider } from "core/providers/ThemeContext";
import { StopwatchProvider } from "core/providers/StopwatchContext";

import "./styles/theme.scss";
import "./styles/antd-overrides.scss";
import "./styles/global.scss";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";
import { ProjectSelectionProvider } from "core/providers/ProjectSelectionContext";

const initialTheme =
  localStorage.getItem("theme") === "dark" ? "dark" : "light";

document.documentElement.setAttribute("data-theme", initialTheme);
document.documentElement.style.colorScheme = initialTheme;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ProjectSelectionProvider>
        <StopwatchProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </StopwatchProvider>
      </ProjectSelectionProvider>
    </AuthProvider>
  </React.StrictMode>,
);
